// extracted by mini-css-extract-plugin
export default {"pageContainer":"styles_pageContainer__kmbup","showShadow":"styles_showShadow__sHl1I"};